// extracted by mini-css-extract-plugin
export default {"introContainer":"EcoPickPage_introContainer__+pa2f","fadeOut":"EcoPickPage_fadeOut__jN1J+","appName":"EcoPickPage_appName__4JlyW","tagline":"EcoPickPage_tagline__wVoK-"};